import { IMaskMixin } from 'react-imask'
import { CFormInput } from '@coreui/react-pro'
import React from 'react'

const CFormInputWithMask = IMaskMixin(({ inputRef, ...props }) => (
  <CFormInput {...props} ref={inputRef} />
))

export default CFormInputWithMask
